import { render, staticRenderFns } from "./roleConfig.vue?vue&type=template&id=34c2487d&"
import script from "./roleConfig.vue?vue&type=script&lang=js&"
export * from "./roleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports